import * as types from "./types";
import { facilitiesApi } from "@apiService";

export const getFacilitiesData = (slug) => {
  return {
    type: types.GET_FACILITIES_DATA,
    payload: facilitiesApi.getFacilities(slug),
  };
};
